import { render, staticRenderFns } from "./verificationRecords.vue?vue&type=template&id=7e0c8b79&scoped=true&"
import script from "./verificationRecords.vue?vue&type=script&lang=js&"
export * from "./verificationRecords.vue?vue&type=script&lang=js&"
import style0 from "./verificationRecords.vue?vue&type=style&index=0&id=7e0c8b79&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0c8b79",
  null
  
)

export default component.exports